export default __webpack_public_path__ + "static/char-s-49-en-93f4e6c526647354976ea065593fe83d.png";